/* global consentPolicyManager, Wix */
import { COOKIE_CONSENT_DISALLOWED } from './utils/constants';
var CONSENT_POLICY_CATEGORIES = [
    'essential',
    'functional',
    'analytics',
    'advertising',
];
export function verifyConsentPolicy(category) {
    verifyConsentPolicyCategoryIfExists(category);
    var policy = getConsentPolicy();
    if (typeof policy !== 'undefined' && !policy[category]) {
        throw COOKIE_CONSENT_DISALLOWED;
    }
}
export function verifyConsentPolicyCategoryIfExists(category) {
    if (!category) {
        return;
    }
    if (CONSENT_POLICY_CATEGORIES.indexOf(category) === -1) {
        var categories = CONSENT_POLICY_CATEGORIES.map(function (v) { return "'" + v + "'"; }).join(', ');
        throw new Error("category must be one of " + categories);
    }
}
function getConsentPolicy() {
    var policy = (resolveByNativeAPI() || resolveByJsSDK() || none()).policy;
    return policy;
}
function resolveByNativeAPI() {
    return (typeof consentPolicyManager === 'object' &&
        consentPolicyManager.getCurrentConsentPolicy &&
        consentPolicyManager.getCurrentConsentPolicy());
}
function resolveByJsSDK() {
    return (typeof Wix === 'object' &&
        Wix.Utils &&
        Wix.Utils.getCurrentConsentPolicy &&
        Wix.Utils.getCurrentConsentPolicy());
}
function none() {
    return {};
}
//# sourceMappingURL=consent-policy.js.map